import { Button, Card, Grid, IconButton, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useState } from "react"
import { MoveCategoryDialog } from "./move-category-dialog"

export function CategoryItem({ item }) {
    const { readOnly, setCategoryId, refresh } = useBoundContext()
    const [moveOpen, setMoveOpen] = useState(false)
    const isFile = item.type === "file"
    const icon = isFile ? "eva:file-text-fill" : "eva:folder-fill"
    const color = isFile ? (item.taskCount > 0 ? "primary.main" : "text.disabled") : "warning.main"

    const gridProps = isFile ? { xs: 12, sm: 12, md: 12, lg: 8, xl: 6 } : { xs: 12, sm: 6, md: 6, lg: 4, xl: 3 }

    return (
        <Grid item {...gridProps}>
            <Card
                data-cy={`category-item: ${item.name}`}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                }}
            >
                <Button
                    data-cy={`category-item-navigate: ${item.name}`}
                    onClick={handleClick}
                    variant="text"
                    color="inherit"
                    sx={{
                        flexGrow: 1,
                        justifyContent: "flex-start",
                        textTransform: "none",
                        px: 2,
                        py: 1,
                        minWidth: 0,
                        textAlign: "left",
                        "&:hover": { bgcolor: "action.hover", color: "primary.main" },
                    }}
                >
                    <Iconify
                        icon={icon}
                        sx={{
                            mr: 1,
                            color,
                            width: 24,
                            height: 24,
                            flexShrink: 0,
                        }}
                    />
                    <Typography variant="subtitle2" noWrap title={item.name} sx={{ flexGrow: 1 }}>
                        {item.name}
                    </Typography>
                </Button>

                {!readOnly && (
                    <IconButton
                        aria-label="Move category"
                        data-cy="category-item-move"
                        size="small"
                        color="primary"
                        onClick={(e) => {
                            e.stopPropagation()
                            setMoveOpen(true)
                        }}
                        sx={{ mr: 1, ml: 0.5 }}
                    >
                        <Iconify icon="eva:move-outline" width={16} height={16} />
                    </IconButton>
                )}
            </Card>

            {!readOnly && (
                <MoveCategoryDialog
                    open={moveOpen}
                    onClose={() => setMoveOpen(false)}
                    item={item}
                    onMoved={() => {
                        setMoveOpen(false)
                        refresh()
                    }}
                />
            )}
        </Grid>
    )

    function handleClick() {
        setCategoryId(item.id)
    }
}
